import React, { useCallback, useState } from 'react';
import DateRangePicker from './date-range-picker';

const OrderFilterOptions = ({
  setSelectedChoice,
  setStartDate,
  setEndDate,
  selectedOrders=[],
  handleCreateSR
}: any) => {
  const [selectedOption, setSelectedOption] = useState('all');

  const handleOptionChange = (event) => {
    setSelectedChoice(event.target.value)
    setSelectedOption(event.target.value);
  };

  const handleFocus: React.FocusEventHandler<HTMLDivElement> = (event) => {
    setSelectedOption('range');
    setSelectedChoice('range');
  };

  const handleSetStartDate = useCallback((date: Date) => {
    console.log('start date in filter', date)
    setSelectedOption('range');
    setSelectedChoice('range');
    setStartDate(date);
  }, []);

  const handleSetEndDate = useCallback((date: Date) => {
    console.log('end date in filter', date)
    setSelectedChoice('range');
    setSelectedOption('range');
    setEndDate(date);
  }, []);

  return (
    <div className="w-full mx-auto p-4">
      <div className="uppercase text-xl pb-4">Create Settlement Request for:</div>
      <div className="flex flex-wrap items-center justify-start space-x-4 bg-white rounded-lg shadow-md p-4">
        <div className="flex flex-wrap gap-4">
          <label className={`flex items-center space-x-2 cursor-pointer p-2 rounded-md transition-colors ${selectedOption === 'all' ? 'bg-blue-100 text-blue-600' : 'hover:bg-gray-100'}`}>
            <input
              type="radio"
              name="sortOption"
              value="all"
              checked={selectedOption === 'all'}
              onChange={handleOptionChange}
              className="hidden"
              aria-label="All Pending Orders"
            />
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color={`${selectedOption === 'all' ? 'text-blue-600' : 'text-gray-500'}`} fill="none">
              <path d="M3.5 9V14C3.5 17.7712 3.5 19.6569 4.67157 20.8284C5.84315 22 7.72876 22 11.5 22H12.5C16.2712 22 18.1569 22 19.3284 20.8284C20.5 19.6569 20.5 17.7712 20.5 14V10C20.5 6.22876 20.5 4.34315 19.3284 3.17157C18.1569 2 16.2712 2 12.5 2H12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M13.5 17H17.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M13.5 7H17.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M13.5 12H17.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M6.5 16.5C6.5 16.5 7.46758 16.7672 8 18C8 18 9 15 11 14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M10 5H3.5M10 5C10 4.15973 7.67332 2.58984 7.08333 2M10 5C10 5.84027 7.67331 7.41016 7.08333 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
            
            <span>All Pending Orders</span>
          </label>
          <label className={`flex items-center space-x-2 cursor-pointer p-2 rounded-md transition-colors ${selectedOption === 'selected' ? 'bg-blue-100 text-blue-600' : 'hover:bg-gray-100'}`}>
            <input
              type="radio"
              name="sortOption"
              value="selected"
              checked={selectedOption === 'selected'}
              onChange={handleOptionChange}
              className="hidden"
              aria-label="Selected Orders"
            />
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color={`${selectedOption === 'selected' ? 'text-blue-600' : 'text-gray-500'}`} fill="none">
              <path d="M11 6L21 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
              <path d="M11 12L21 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
              <path d="M11 18L21 18" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
              <path d="M3 7.39286C3 7.39286 4 8.04466 4.5 9C4.5 9 6 5.25 8 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M3 18.3929C3 18.3929 4 19.0447 4.5 20C4.5 20 6 16.25 8 15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>            
            <span>Selected Orders</span>
          </label>
          <label className={`flex items-center space-x-2 cursor-pointer p-2 rounded-md transition-colors ${selectedOption === 'range' ? 'bg-blue-100 text-blue-600' : 'hover:bg-gray-100'}`}>
            <input
              type="radio"
              name="sortOption"
              value="range"
              checked={selectedOption === 'range'}
              onChange={handleOptionChange}
              className="hidden"
              aria-label="Orders Between"
            />
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color={`${selectedOption === 'range' ? 'text-blue-600' : 'text-gray-500'}`} fill="none">
            <path d="M11 13H16M8 13H8.00898M13 17H8M16 17H15.991" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M18 2V4M6 2V4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M2.5 12.2432C2.5 7.88594 2.5 5.70728 3.75212 4.35364C5.00424 3 7.01949 3 11.05 3H12.95C16.9805 3 18.9958 3 20.2479 4.35364C21.5 5.70728 21.5 7.88594 21.5 12.2432V12.7568C21.5 17.1141 21.5 19.2927 20.2479 20.6464C18.9958 22 16.9805 22 12.95 22H11.05C7.01949 22 5.00424 22 3.75212 20.6464C2.5 19.2927 2.5 17.1141 2.5 12.7568V12.2432Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M3 8H21" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
            <span>Orders Between</span>
            <div onFocus={handleFocus} tabIndex={0}>
              <DateRangePicker 
                setSelectedStartDate={handleSetStartDate}
                setSelectedEndDate={handleSetEndDate}
              />
            </div>            
          </label>
          <div className='flex flex-col items-end justify-end'>
            <button
              onClick={handleCreateSR}
              className="flex w-44 h-14 items-center justify-center py-1 px-4 m-1 md:m-4 bg-blue-700 text-white rounded hover:bg-blue-800 transition-all duration-200"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#ffffff" fill="none">
                <path d="M19.7502 11V10C19.7502 6.22876 19.7502 4.34315 18.5786 3.17157C17.407 2 15.5214 2 11.7502 2H10.7503C6.97907 2 5.09346 2 3.92189 3.17156C2.75032 4.34312 2.7503 6.22872 2.75027 9.99993L2.75024 14C2.7502 17.7712 2.75019 19.6568 3.92172 20.8284C5.09329 21.9999 6.97897 22 10.7502 22" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M7.25024 7H15.2502M7.25024 12H15.2502" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                <path d="M13.2502 20.8268V22H14.4236C14.833 22 15.0377 22 15.2217 21.9238C15.4058 21.8475 15.5505 21.7028 15.84 21.4134L20.6636 16.5894C20.9366 16.3164 21.0731 16.1799 21.1461 16.0327C21.285 15.7525 21.285 15.4236 21.1461 15.1434C21.0731 14.9961 20.9366 14.8596 20.6636 14.5866C20.3905 14.3136 20.254 14.1771 20.1067 14.1041C19.8265 13.9653 19.4975 13.9653 19.2173 14.1041C19.0701 14.1771 18.9335 14.3136 18.6605 14.5866L18.6605 14.5866L13.8369 19.4106C13.5474 19.7 13.4027 19.8447 13.3265 20.0287C13.2502 20.2128 13.2502 20.4174 13.2502 20.8268Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" />
            </svg>
              <span className='pl-2'>{`${selectedOption === 'selected' ? 'Select Orders' : 'Create SR'}`}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderFilterOptions;
